import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/pro-solid-svg-icons";

import styles from "./notificationWarning.module.scss";

export const NotificationWarning = () => {
  return (
    <div className={styles.warning}>
      <FontAwesomeIcon icon={faUsers} />
      <span>
        This will <strong>immediately</strong> send emails to all users selected
      </span>
    </div>
  );
};
